import React from "react";

export default function LegendItem({dataset, onClick, active}) {
    return (
        <li onClick={onClick} className={`legendItem${active ? ' active' : ''}`}>
        <span style={{
            borderColor: dataset.borderColor,
            backgroundColor: dataset.backgroundColor
        }} className={'legendItemMarker'}/>
            {dataset.legendLabel}
        </li>
    )
}
